import * as React from 'react';
import './pricing.css';
import { StoreState, CustomAction } from '../store';
import { Dispatch, bindActionCreators } from 'redux';
import { selectGeneric } from '../store/actions/generic.actions';
import { connect } from 'react-redux';
import { Signup_Details_Obj } from '../store/reducers/signup_details.reducers';
// import ProductShowcase from './product_showcase/product_showcase.component';
import { Product_Obj } from '../store/reducers/product_list.reducers';
import Button from 'src/custom_components/button/button.component';
import { withRouter } from 'react-router';
// import Tablet from '../custom_components/icons/tablet';
// import Users from '../custom_components/icons/users';
import { History } from 'history';

export interface Pricing_Props {
    signup_details: Signup_Details_Obj;
    product_list: Product_Obj[];
    product: Product_Obj;

    updateDetails: typeof selectGeneric;
    selectProduct: typeof selectGeneric;
}

class Pricing extends React.PureComponent<Pricing_Props> {

    variant_desc_a: string = 'Pick a package, select the amount of users and devices';
    variant_desc_b: string = 'If you need additional devices, you can add them to your subscription during checkout';
    variant_desc_c: string = 'Every tier benefits from all available features';

    render() {

        const Submit_Button = withRouter(
            ({history}) => (
                <Button 
                    onClick={this.getStarted.bind(this, history)} 
                    disabled={false}
                    text="Sign Up" 
                    color="#673AB7"
                    className="signup-button" 
                    text_color="white">
                </Button>
            )
        )

        // const Contact_Button = withRouter(
        //     ({history}) => (
        //         <Button 
        //             onClick={this.contactUs.bind(this, history)} 
        //             disabled={false}
        //             text="Contact Us" 
        //             color="#673AB7" 
        //             className="signup-button"
        //             text_color="white">
        //         </Button>
        //     )
        // )

        return (
            <div>
                <div className="main-pricing">
                    <div className="main-pricing-block main-feature-spacing main-shadow">
                        <div className="main-pricing-title main-back-color">
                            <span className="main-cta-title">Free</span>
                            <div className="main-pricing-row">
                                <span className="main-cta-comment">Perfect for small teams, startups or if you want to try before you commit</span>
                            </div>
                        </div>
                        <div className="main-pricing-contents main-feature-color">
                            <div className="main-pricing-row main-shadow-minimal">
                                <div className="main-pricing-row-item">
                                    <span className="main-cta-sub-title-item-alt">Users</span>
                                </div>
                                <div className="main-pricing-row-quantity">
                                    <span className="main-cta-sub-title-quantity-alt">5</span>
                                </div>
                            </div>
                            <div className="main-pricing-row main-shadow-minimal">
                                <div className="main-pricing-row-item">
                                    <span className="main-cta-sub-title-item-alt">Letter Templates</span>
                                </div>
                                <div className="main-pricing-row-quantity">
                                    <span className="main-cta-sub-title-quantity-alt">5</span>
                                </div>
                            </div>
                            <div className="main-pricing-row main-shadow-minimal">
                                <div className="main-pricing-row-item">
                                    <span className="main-cta-sub-title-item-alt">Leave Applications</span>
                                </div>
                                <div className="main-pricing-row-quantity">
                                    <span className="main-cta-sub-title-quantity-alt">15 / month</span>
                                </div>
                            </div>
                            <div className="main-pricing-row main-shadow-minimal">
                                <div className="main-pricing-row-item">
                                    <span className="main-cta-sub-title-item-alt">Attendance Entries</span>
                                </div>
                                <div className="main-pricing-row-quantity">
                                    <span className="main-cta-sub-title-quantity-alt">500 / month</span>
                                </div>
                            </div>
                        </div> 
                        <div className="main-pricing-action-row main-feature-color">
                            <Submit_Button></Submit_Button>
                        </div>   
                    </div>
                    <div className="main-pricing-block-bold main-feature-spacing main-shadow">
                        <div className="main-pricing-title main-back-color">
                            <span className="main-cta-title">Standard</span>
                            <div className="main-pricing-row">
                                <span className="main-cta-comment">Pick up where you left off in the free tier, no interruptions. Simply increase your usage limits.</span>
                            </div>
                        </div>
                        <div className="main-pricing-contents-bold main-feature-color">
                            <div className="main-pricing-row main-shadow-minimal">
                                <div className="main-pricing-row-item">
                                    <span className="main-cta-sub-title-item-alt"></span>
                                </div>
                                <div className="main-pricing-row-quantity">
                                    <span className="main-cta-sub-title-quantity-alt">Monthly</span>
                                </div>
                            </div>
                            <div className="main-pricing-row main-shadow-minimal">
                                <div className="main-pricing-row-item">
                                    <span className="main-cta-sub-title-item-alt">Users</span>
                                </div>
                                <div className="main-pricing-row-quantity">
                                    <span className="main-cta-sub-title-quantity-alt">+$2.00 / user</span>
                                </div>
                            </div>
                            <div className="main-pricing-row main-shadow-minimal">
                                <div className="main-pricing-row-item">
                                    <span className="main-cta-sub-title-item-alt">Letter Templates</span>
                                </div>
                                <div className="main-pricing-row-quantity">
                                    <span className="main-cta-sub-title-quantity-alt">+$0.05 / letter</span>
                                </div>
                            </div>
                            <div className="main-pricing-row main-shadow-minimal">
                                <div className="main-pricing-row-item">
                                    <span className="main-cta-sub-title-item-alt">Leave Applications</span>
                                </div>
                                <div className="main-pricing-row-quantity">
                                    <span className="main-cta-sub-title-quantity-alt">+$0.20 / application</span>
                                </div>
                            </div>
                            <div className="main-pricing-row main-shadow-minimal">
                                <div className="main-pricing-row-item">
                                    <span className="main-cta-sub-title-item-alt">Attendance Entries</span>
                                </div>
                                <div className="main-pricing-row-quantity">
                                    <span className="main-cta-sub-title-quantity-alt">+$0.01 / 10 entries</span>
                                </div>
                            </div>
                        </div> 
                        <div className="main-pricing-action-row main-feature-color">
                            <Submit_Button></Submit_Button>
                        </div>  
                    </div>
                    {/* <div className="main-pricing-block main-feature-spacing main-shadow">
                        <div className="main-pricing-title main-back-color">
                            <span className="main-cta-title">Corporate</span>
                        </div>
                        <div className="main-pricing-contents main-feature-color">
                            <div className="main-pricing-row">
                                <span className="main-cta-comment-alt">More than 100 users? Let's have a chat to figure things out.</span>
                            </div>
                        </div>  
                        <div className="main-pricing-action-row main-feature-color">
                            <Contact_Button></Contact_Button>
                        </div> 
                    </div> */}
                </div>
            </div>
        )
    }

    roundNumber = (number: number) => {
        return (parseFloat('' + number).toFixed(2));
    }

    getStarted = (history: History, event: any) => {
        // let fresh_details: Signup_Details_Obj = {
        //     email: this.props.signup_form.value,
        //     product: null
        // };

        // this.props.updateForm('SIGNUP_DETAILS_UPDATE', fresh_details)

        history.push('/signup')
    }

    contactUs = (history: History, event: any) => {
        // let fresh_details: Signup_Details_Obj = {
        //     email: this.props.signup_form.value,
        //     product: null
        // };

        // this.props.updateForm('SIGNUP_DETAILS_UPDATE', fresh_details)

        history.push('/contact')
    }
}

export function mapStateToProps({ signup_details, product_list, product }: StoreState) {
    return {
      signup_details: signup_details,
      product_list: product_list,
      product: product
    }
}
  
export function mapDispatchToProps(dispatch: Dispatch<CustomAction>) {
    return bindActionCreators({
        updateDetails: selectGeneric,
        selectProduct: selectGeneric
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Pricing);


// WEBPACK FOOTER //
// ./src/pricing/pricing.component.tsx